import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {VideoGridElement} from '../../_shared/videos-grid/video-grid-element.model';

@Component({
    selector: 'app-ApplyForHOX',
    templateUrl: './ApplyForHOX.component.html',
    styleUrls: ['./ApplyForHOX.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ApplyForHOXComponent {

  videos: VideoGridElement[] = [
    {
      url: 'https://www.youtube.com/embed/RWvuJaZkbrc?list=PL99qj8Q3_1psopvHemZMeUntqzEw7-m5a',
      title: 'Presentation 3: Homeowners\' Exemption with Frank Diaz, Jr.',
      powerpoint: null
    }
  ];

  constructor() { }
}
